import { coreService } from "../services/coreService";
import { buildQuery } from "../lib/network";

export const getAgencySettings = (headers: any) => () =>
  buildQuery(coreService.agencySettingsList({ headers }), (x) => x.data);

export const getPickList = (headers: any) => (picklistName: string) => {
  return buildQuery(coreService.agencyPicklistDetail(picklistName, { headers }), (response) => response.data?.data);
};

export const getPicklistOptions = (headers: any) => () =>
  buildQuery(coreService.agencyPicklistList({ headers }), (response) => response.data);

export const getAgencyCrmFieldAttributes = (headers: any) => () => {
  return buildQuery(coreService.agencySettingsCrmFieldAttributesList({ headers }), (response) => {
    return response.data;
  });
};

export const getAgencyCeFieldAttributes = (headers: any) => () =>
  buildQuery(coreService.agencySettingsCeFieldAttributesList({ headers }), (response) => response.data);
